// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__T3WP2","name":"ConsentHeader_name__3qEEu","birthday":"ConsentHeader_birthday__3u8Uz","skeleton":"ConsentHeader_skeleton__12E8x"};